import styled from 'styled-components';
import { FundraiserCardMinWidth } from '../../utils/constants';

export const Explore = styled.div`
    .center {
        align-items: center;
    }
`;
